import React, { useEffect, useState } from 'react';
import GeneratePdf from '../../../../components/GeneratePdf';
import { getFormatedNumber } from '../../../../services/appService';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useDispatch, useSelector } from 'react-redux';
import { getInsuranceInfoRpt, loadInsuranceInfoRpt } from '../../../store/reports';
import Moment from 'react-moment';

const InsuranceInformation = () => {


    const [parterInsuranceReports, setParterInsuranceReports] = useState([]);
    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState("");
    const [selectedColData, setSelectedColData] = useState([]);
    const [selectedInsuranceType, setSelectedInsuranceType] = useState(0);
    const [expandedRow, setExpandedRow] = useState(null); // Only one expanded at a time
    const [showAllDetails, setShowAllDetails] = useState(false);
    const [insuranceExpired, setInsuranceExpired] = useState(0);

    const insuranceTypes = [
        { id: 1, name: "Sub-Contractors", pmId: 3 },
        { id: 2, name: "Recruiter", pmId: 5 }
    ];

    const insuranceInfoRptSelector = useSelector(getInsuranceInfoRpt);

    const dispatch = useDispatch();

    useEffect(() => {
        setParterInsuranceReports(insuranceInfoRptSelector);
    }, [insuranceInfoRptSelector]);

    const handlepdfShowHide = () => {
        setPdfShowHide(!pdfShowHide);
    }

    const handleGenerateRpt = () => {
        // Dispatch action to load report data
        dispatch(loadInsuranceInfoRpt(selectedInsuranceType, insuranceExpired, 0, 0));
    }

    const subcontractorExportPDF = () => {
        let headers = [
            [
                "ID",
                "Company Name",
                "Company Email",
                "Company Phone",
                "Insurance Company",
                "Insurance Details",
                "Key Contact ID",
                "Key Contact Name",
                "Key Contact Email",
                "Key Contact Phone",
            ],
        ];

        let data = [];

        parterInsuranceReports.map((item) => {

            // Main row for subcontractor
            data.push([
                item.id || "",
                item.name || "",
                item.email || "",
                item.phone || "",
                item.insuranceCompany || "",
                "", // placeholder for insurance details
                item.keyId || "",
                item.keyName || "",
                item.keyEmail || "",
                item.keyPhone || "",
            ]);

            if (item.insuranceDetails && item.insuranceDetails.length > 0) {
                data.push([
                    "", // empty for main columns
                    "", // empty for main columns
                    "Type", // empty for main columns
                    "Policy #", // empty for main columns
                    "Expiration", // empty for main columns
                    "Remaining Days",
                    "", // empty for main columns
                    "", // empty for main columns
                ]);
                // Sub-rows for insurance details
                item.insuranceDetails.forEach((detail) => {
                    data.push([
                        "", // empty for main columns
                        "", // empty for main columns
                        `${detail.coverageType || ""}`,
                        `${detail.policyNumber || ""}`,
                        `${detail.expirationDate
                            ? new Date(detail.expirationDate).toLocaleDateString()
                            : "N/A"
                        }`,
                        `${detail.daysRemaining || "N/A"}`,
                        "", // empty for main columns
                        "", // empty for main columns
                    ]);
                });
            }

        });

        setSelectedCol(headers);
        setSelectedColData(data);
        setPdfShowHide(true);
    };

    const handleInsuranceTypeChange = (e) => {
        setSelectedInsuranceType(parseInt(e.target.value));
        setParterInsuranceReports([]);
    }

    const toggleRow = (id) => {
        setExpandedRow(prev => (prev === id ? null : id));
    };

    const handleInsuranceExpiredChange = (e) => {
        console.log("Expiration Status:", e.target.value);
        setInsuranceExpired(parseInt(e.target.value));
    }

    return (
        <>
            <div className="card shadow-none border">
                <div className="card-header text-center p-3 bg-lighter">
                    <h4 className="mb-0">
                        Insurance Information Reports
                    </h4>
                </div>
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-3">
                            <select
                                name="insuranceType"
                                id="insuranceType"
                                className="form-control form-control-sm"
                                onChange={handleInsuranceTypeChange}
                                value={selectedInsuranceType}
                            >
                                <option value="0">Select Entity</option>
                                {insuranceTypes.map((y) => (
                                    <option value={y.pmId}>
                                        {y.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <select
                                name="insuranceExpired"
                                id="insuranceExpired"
                                className="form-control form-control-sm"
                                onChange={handleInsuranceExpiredChange}
                                value={insuranceExpired}
                            >
                                <option value="0">Select Expiration</option>
                                <option value="1">Expired</option>
                                <option value="2">Active</option>
                                <option value="3">Data not submitted</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            <button
                                className="btn btn-sm btn-outline-default"
                                disabled={selectedInsuranceType === 0}
                                onClick={handleGenerateRpt}
                            >
                                Generate
                            </button>
                             <button
                                type="button"
                                className="btn btn-sm btn-outline-default"
                                disabled={parterInsuranceReports?.length === 0}
                                onClick={() => setShowAllDetails(!showAllDetails)}
                            >
                                {showAllDetails ? " Hide All Details" : " Show All Details"}
                            </button>
                        </div>
                        <div className="col-md-3 text-right">
                            <ReactHTMLTableToExcel
                                id="subcontractorTable"
                                className="btn btn-sm btn-outline-default"
                                table="sub_ach_rpt"
                                filename="insurance_Report"
                                sheet="insurance_Report"
                                buttonText="Export to Excel"
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-default"
                                disabled={parterInsuranceReports?.length === 0}
                                onClick={subcontractorExportPDF}
                            >
                                Generate PDF
                            </button>
                        </div>
                        <div className="col-md-12 mt-3">
                            <div className="table-responsive">
                                <table
                                    className="table align-items-center table-flush table-hover table-striped mb-2 border"
                                    id="sub_ach_rpt"
                                >
                                    <thead className="thead-light">
                                        <th>ID</th>
                                        <th>Company Name</th>
                                        <th>Company Email</th>
                                        <th>Company Phone</th>
                                        <th>insurance Company</th>
                                        <th>insurance Details</th>
                                        <th>Key Contact ID</th>
                                        <th>Key Contact Name</th>
                                        <th>Key Contact Email</th>
                                        <th>Key Contact Phone</th>
                                    </thead>

                                    <tbody>
                                        {parterInsuranceReports?.map(item =>
                                            <>
                                                <tr>
                                                    <td>{item.id}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.email}</td>
                                                    <td>{item.phone && getFormatedNumber(item.phone)}</td>
                                                    <td>{item.insuranceCompany}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-link p-0"
                                                            onClick={() => toggleRow(item.id)}
                                                        >
                                                            {(expandedRow === item.id || showAllDetails) ? "Hide Details" : "View Details"}
                                                        </button>
                                                    </td>
                                                    <td>{item.keyId}</td>
                                                    <td>{item.keyName}</td>
                                                    <td>{item.keyEmail}</td>
                                                    <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                                </tr>
                                                {(expandedRow === item.id || showAllDetails) && (
                                                    <tr>
                                                        <td colSpan={4} className='bg-white'></td>
                                                        <td colSpan={4} className='bg-white'>
                                                            <table className="table mb-0 table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Type</th>
                                                                        <th>Policy #</th>
                                                                        <th>Expiration</th>
                                                                        <th>Remaining Days</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {item.insuranceDetails?.map((detail, index) => (
                                                                        <tr key={index}>
                                                                            <td>{detail.coverageType}</td>
                                                                            <td>{detail.policyNumber}</td>
                                                                            <td>
                                                                                {detail.expirationDate
                                                                                    ? <Moment format="MMM Do YYYY">
                                                                                        {detail.expirationDate}
                                                                                    </Moment>
                                                                                    : "N/A"}
                                                                            </td>
                                                                            <td>{detail.daysRemaining ?? "N/A"}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td colSpan={2} className='bg-white'></td>
                                                    </tr>
                                                )}
                                            </>

                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <GeneratePdf
                handlepdfShowHide={handlepdfShowHide}
                pdfShowHide={pdfShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GeneratePdf>
        </>
    );
};

export default InsuranceInformation;